export const CLASS_NAMES = [
    [
        'apple', 'apricot', 'banana', 'kiwi', 'lemon', 'orange', 'peach', 'pear'
    ],
    [
        'tomato', 'cabbage', 'corn', 'cucumber', 'eggplant', 'onion', 'pepper', 'pumpkin'
    ]
]


